<template>
    <modal :show.sync="show" modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Add Bank</h3>
        <b-form role="form" @submit.prevent="addBank">
            <b-row v-if="!form.bank_code">
                <b-col cols="12">
                    <b-form-group label="Bank">
                        <el-select v-model="form.bank_code" filterable placeholder="Select" @change="getBankerListHandler">
                            <el-option
                            v-for="bank in banks"
                            :key="bank.bank_code"
                            :label="bank.recommend ? '⭐ ' + bank.bank_name : bank.bank_name"
                            :value="bank.bank_code"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-else>
                <b-col cols="6">
                    <b-form-group label="Bank">
                        <el-select v-model="form.bank_code" filterable placeholder="Select" @change="getBankerListHandler">
                            <el-option
                            v-for="bank in banks"
                            :key="bank.bank_code"
                            :label="bank.recommend ? '⭐ ' + bank.bank_name : bank.bank_name"
                            :value="bank.bank_code"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Banker">
                        <el-select v-model="form.banker_id" filterable placeholder="Select Banker" no-data-text="Banker Not Available">
                            <el-option
                            v-for="banker in bankers"
                            :key="banker.id"
                            :label="banker.name"
                            :value="banker.id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Loan Officer">
                        <el-select v-model="form.prod_loan_officer_id" clearable filterable placeholder="Select Loan Officer" disabled>
                            <el-option
                            v-for="loan_officer in userLoanOfficerList"
                            :key="loan_officer.id"
                            :label="loan_officer.name"
                            :value="loan_officer.id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="SPA Price (RM)">
                        <b-form-input
                        v-model="form.spa_price"
                        type="text"
                        required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Margin of Finance (%)">
                        <b-form-input
                        v-model="form.margin_finance"
                        type="text"
                        required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Interest (%)">
                        <b-form-input
                        v-model="form.interest"
                        type="text"
                        required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Tenure Year(s)">
                        <b-form-input
                        v-model="form.tenure_years"
                        type="text"
                        required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" >
                    <b-form-group label="Additional Cost">
                        <b-form-input
                        v-model="form.prod_bnk_add_cost"
                        type="number"
                        step="0.01"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6" class="mb-2">
                    <b-form-group label="Loan Amount" class="mb-2">
                        <b-form-input
                        v-model="form.loan_amount"
                        type="text"
                        step="0.01"
                        required
                        ></b-form-input>
                    </b-form-group>
                    <b-form-checkbox
                    class="text-muted"
                    v-model="is_override_loan_amount"
                    >
                    Override
                    </b-form-checkbox>
                </b-col>
                <b-col cols="6">
                    <p class="text-xs">Installment</p>
                    <h3 class="mb-0">RM{{ form.installment | moneyFormatter }}</h3>
                </b-col>
                <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button variant="primary" type="submit" class="w-100" :disabled="is_loading_btn">Save</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { usePMPStore } from '@/stores/pmpStore'
import { useProductStore } from '@/stores/productStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import {
  calculateInstallment, 
  calculateLoanAmount,
} from '@/assets/js/calculator.js'
import {isEqual, cloneDeep} from 'lodash'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import { useHestiaStore } from "@/stores/hestiaStore"

export default {
    props:{
        show_add_bank: Boolean,
        product: Object
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            is_override_loan_amount:false,
            form: {
                bank_code: '',
                bank_name: '',
                banker_id: '',
                spa_price: '',
                margin_finance: 90,
                interest: '',
                tenure_years: 35,
                loan_amount:'',
                installment: '',
                prod_loan_officer_id: '',
                prod_bnk_add_cost: '',
            },
            banks:[],
            bankers: [],
            dsr_bank: null,
            is_loading_btn: false,
            bank_eligibles: [],
        }
    },
		created() {
      this.getBankerListHandler(null);
    },
    computed: {
        ...mapState(useCustomerStore, ['current_eligibility']),
        ...mapState(useAccessControlStore, ['userBankerList', 'userLoanOfficerList']),
        show: {
            get() {
                return this.show_add_bank
            },
            set(newVal) {
                this.$emit('update:show_add_bank', newVal)
            },
        },
    },
    watch:{
        product:{
            async handler(newVal){
							if(!_gHlp.isEmpty(newVal)){
								this.form.spa_price = newVal.product_detail.prod_pm_spa_price
                this.form.prod_loan_officer_id = newVal.prod_loan_officer_id
                try{
                    if(newVal.product_detail.prod_pm_property_src == 'HESTIA') {
                        const projectBanks = await this.getHestiaProjectBanks(newVal.product_detail.prod_pm_property_id)
                        this.banks = projectBanks
                    } else {
                        this.banks = await this.getPMPProjectBanks(newVal.product_detail.prod_pm_property_id)
                    }
									this.bank_eligibles = await this.getBankEligibilities()
                }catch(e){
									this.errorFunction(e)
                }
							}
            },
            immediate:true
        },
        'form.spa_price':{
            handler(newVal){
                if(!this.is_override_loan_amount){
                    this.form.loan_amount = calculateLoanAmount(newVal, this.form.margin_finance)
                }
            },
            immediate: false,
        },
        'form.margin_finance':{
            handler(newVal){
                if(!this.is_override_loan_amount){
                    this.form.loan_amount = calculateLoanAmount(this.form.spa_price, newVal)
                }
            },
            immediate: false,
        },
        'form.bank_code':{
            async handler(newVal){
                let bank_dsr_info = this.bank_eligibles.find(bank => bank.bank_code == newVal)
                if(!bank_dsr_info){
                    this.form.interest = 0
                    this.form.tenure_years = 35
                    this.form.loan_amount = calculateLoanAmount(this.form.spa_price, this.form.margin_finance)
                    this.form.installment = calculateInstallment(this.form.loan_amount, this.form.interest, this.form.tenure_years)
                    return
                }
                this.dsr_bank = bank_dsr_info
                this.form.interest = bank_dsr_info.bank_loan_interest_rate
                this.form.tenure_years = bank_dsr_info.bank_loan_tenure_year
                this.form.loan_amount = calculateLoanAmount(this.form.spa_price, this.form.margin_finance)
                this.form.installment = calculateInstallment(this.form.loan_amount, this.form.interest, this.form.tenure_years)
            },
        },
        'form':{
            handler(newVal){
                this.form.installment = calculateInstallment(newVal.loan_amount, newVal.interest, newVal.tenure_years)
            },
            deep: true
        },
    },
    methods:{
        ...mapActions(usePMPStore, ['getPMPProjectBanks', 'syncV2CaseToPMP']),
        ...mapActions(useHestiaStore, ['getHestiaProjectBanks']),
        ...mapActions(useProductStore, ['addPropertyProductBank', 'getBankersBasedOnBank','sendEmailToBanker']),
        async getBankEligibilities(){
            try{
                const res = await axios.get(services.customer + 'customer/' + this.product.prod_customer_id +'/dsr.eligibilities', {headers: getHeader()})
                return res.data.data.bank_eligibilities
            }catch(e){
                this.errorFunction(e)
            }
        },
        async getBankerListHandler(bank_code){
            this.is_loading_bank = true
						try{
								this.bankers = cloneDeep(this.userBankerList);
								this.bankers = await this.getBankersBasedOnBank(cloneDeep(this.userBankerList), bank_code, this.product.prod_type);
								let banker = this.bankers.find(bBank => bBank.id == this.form.banker_id)
                if(!banker){
                    this.form.banker_id = null
                }
								let selected_bank = this.banks.find(bank => bank.bank_code == bank_code)
								if(!_gHlp.isEmpty(selected_bank)){
                    this.form.bank_name = selected_bank.bank_name
                }

								this.is_loading_bank = false
            }catch(e){
								this.is_loading_bank = false
                _gNotif.errorFunction(e)
            }
        },
        async addBank(){
            let bank = {
                "prod_bnk_prod_id": this.product.prod_id,
                "prod_bnk_name": this.form.bank_name,
                "prod_bnk_logo_url": this.dsr_bank ? this.dsr_bank.bank_image_url : null,
                "prod_bnk_banker_id": this.form.banker_id ?? null,
                "prod_bnk_stage_status":"Pending Submission",
                "prod_bnk_loan_amount": this.form.loan_amount,
                "prod_bnk_spa_amount": this.form.spa_price,
                "prod_bnk_interest": this.form.interest,
                "prod_bnk_margin": this.form.margin_finance,
                "prod_bnk_tenure": this.form.tenure_years,
                "prod_bnk_gross_cashback": null,
                "prod_bnk_installment": this.form.installment,
                "prod_bnk_code": this.form.bank_code,
                "prod_bnk_add_cost": this.form.prod_bnk_add_cost
            }
            try{
                this.is_loading_btn = true
                const res = await axios.post(services.product + 'product-bank', bank, {headers: getHeader()})
                if(this.product.product_detail.prod_pm_property_src != 'HESTIA') {
                    const pmpRes = await this.syncV2CaseToPMP(this.product.prod_id)
                }
								this.sendEmailToBanker(res.data,this.product)
                this.resetField()
                this.is_loading_btn = false
                this.$emit('update:show_add_bank', false)
                caseEventBus.$emit('refresh-cases')
                this.notifySuccess('<b>Bank</b> - Successfully Added.')
            }catch(e){
                this.is_loading_btn = false
                this.errorFunction(e)
            }
        },
        resetField(){
            this.resetFormToNull(this.form, ['margin_finance'])
            this.dsr_bank = null
        }
    }
}
</script>